import React from 'react';

import { Col, Row } from 'antd';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { IRootReducers } from 'src/reducers';
import { ResourceTypeEnum } from 'src/shared/enums';
import { scrollDown, setResourceGuidePointTitle } from 'utils';

const { ACTIVATION_BUTTON } = ResourceTypeEnum;

const ChallengeResourceGuide = ({ modules, resourceGuideConfig }) => {
  if (!modules || !resourceGuideConfig) return <></>;
  let sortedModules = [];
  const firstModule = modules.find((module) => !module.resource.depResouce);

  const orderModulesByDepResource = (parentDepResource) => {
    const nextModule = modules.find((module) =>
      module.resource.dependenciesList.find(
        ({ idDependency }) => idDependency === parentDepResource.idResource
      )
    );

    if (nextModule && nextModule.idResource !== parentDepResource?.idResource) {
      sortedModules.push(nextModule);
      return orderModulesByDepResource(nextModule);
    }
  };

  sortedModules.push(firstModule);
  orderModulesByDepResource(firstModule);

  sortedModules = sortedModules.filter(
    (module) => module.type !== ACTIVATION_BUTTON
  );

  return (
    <Row className="resource-guide" justify="center">
      <Col span={24} className="resource-guide__header">
        <h4 className="resource-guide__title">{resourceGuideConfig?.title}</h4>
        <p className="regular-body">{resourceGuideConfig?.description}</p>
      </Col>
      <Row
        className="resource-guide__modules"
        justify="space-between"
        gutter={40}
      >
        {sortedModules?.map((module, index) => {
          const isCompleted = module.config.isCompleted;
          return (
            <Col key={module.key} style={{ position: 'relative' }}>
              <ResourceGuideModule
                module={module}
                showPoints={resourceGuideConfig?.showPoints}
              />
              {index + 1 < sortedModules.length && (
                <div
                  className={`resource-guide__dependency-line ${
                    isCompleted ? 'resource-guide__dependency-line--done' : ''
                  }`}
                />
              )}
            </Col>
          );
        })}
      </Row>
    </Row>
  );
};

const ResourceGuideModule = ({ module, showPoints }) => {
  const { isCompleted, isBlocked, isVisible } = module.config;
  const resourceGuideCurrentState = isCompleted
    ? 'resource-guide__module--completed'
    : isBlocked
    ? 'resource-guide__module--blocked'
    : '';

  return (
    <Col className={`resource-guide__module ${resourceGuideCurrentState}`}>
      <div
        className="icon-container icon__rounded"
        onClick={() => module.key && scrollDown(module.key)}
      >
        <div
          className={`module__icon icon icon--${
            module.config.icon || 'default'
          }`}
        />
        {isCompleted && (
          <div className="icon-completed-container icon__success icon__rounded">
            <div className={`icon icon--check`} />
          </div>
        )}
        {isBlocked && (
          <div className="icon-completed-container icon__grey-primary icon__rounded">
            <div className={`icon icon--padlock`} />
          </div>
        )}
      </div>
      <div className="module__info">
        <p className="module__title small-body title">
          <FormattedMessage id={setResourceGuidePointTitle(module.type)} />
        </p>
        {showPoints && (
          <p className="module__points small-body">
            {module.config.points || 0} points
          </p>
        )}
      </div>
    </Col>
  );
};

const mapStateToProps = (state: IRootReducers) => {
  return {
    modules: state.app.challenge?.challengeResources,
    resourceGuideConfig: state.app.challenge?.challengeResourceGuide.config,
  };
};

export default connect(mapStateToProps)(ChallengeResourceGuide);
